var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90727 2.02005C5.1358 2.01063 2.87204 4.21563 2.78156 6.97567L2.77878 7.14699C2.82484 8.49984 3.28513 9.78943 4.09583 10.8519L4.28623 11.1004C5.06005 12.0843 5.97965 12.9479 7.0122 13.6597L7.26081 13.8271L7.29709 13.8556C7.65099 14.1099 8.12883 14.1099 8.48274 13.8556L8.51294 13.8308C9.33225 13.2994 10.0878 12.6751 10.7645 11.9702C12.1404 10.5137 12.9697 8.88178 13.001 7.22439L13.0011 7.16286C13.0105 4.38434 10.8123 2.11363 8.06071 2.02284L7.90727 2.02005ZM7.90422 2.93247C10.1763 2.94023 12.021 4.75563 12.0895 7.01639L12.0915 7.21572C12.0651 8.60526 11.3376 10.037 10.1068 11.3399C9.47923 11.9936 8.77558 12.5746 8.0124 13.0688L7.96153 13.1071C7.92043 13.1427 7.85947 13.1427 7.81837 13.1071L7.76893 13.0698C6.63203 12.3275 5.6342 11.3903 4.8211 10.3011C4.16616 9.44274 3.77805 8.41642 3.69993 7.34577L3.68846 7.13109C3.69617 4.85352 5.50597 3.00313 7.75978 2.93442L7.90422 2.93247ZM7.88994 5.26789C6.81455 5.26789 5.94277 6.14235 5.94277 7.22106C5.94277 8.29977 6.81455 9.17423 7.88994 9.17423C8.96532 9.17423 9.8371 8.29977 9.8371 7.22106C9.8371 6.14235 8.96532 5.26789 7.88994 5.26789ZM7.88997 6.18035C8.46298 6.18035 8.92749 6.6463 8.92749 7.22108C8.92749 7.79585 8.46298 8.2618 7.88997 8.2618C7.31697 8.2618 6.85245 7.79585 6.85245 7.22108C6.85245 6.6463 7.31697 6.18035 7.88997 6.18035Z",
    fill: "#9597AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e9b8c80a57263f68ee10836d3b5ae58f.svg";
export { ForwardRef as ReactComponent };